// import { activeProducts } from "$lib/firestore/activeProducts"
import { persist, createLocalStorage } from '@macfja/svelte-persistent-store';
import { writable, readable, derived } from 'svelte/store';

import { collection, query, orderBy, limit, onSnapshot, where } from 'firebase/firestore';
import { db } from '$lib/firestore';

import { browser } from '$app/environment';
import { daysRemaining } from '$lib/helpers';
import { logError } from '$lib/helpers/errors';
import { prizes } from './prizes';

export let productStore = writable([]);
export let recentWinnersStore = persist(writable([]), createLocalStorage(), 'recentWinnersStore');

let isDataFetched = false;

productStore.subscribe(async (items) => {
	if (isDataFetched) return;
	if ((items === null || items.length === 0) && browser) {
		console.log('fetch product data');
		try {
			await fetchData();
			isDataFetched = true;
		} catch (error) {
			console.error('Error fetching data:', error);
			logError(error, 'products.js:productStore.subscribe');
		}
	}
});

// Reset isDataFetched flag every 5 minutes
setInterval(
	() => {
		isDataFetched = false;
	},
	5 * 60 * 1000
);

async function fetchData() {
	const maxRetries = 3;
	let attempt = 0;
	let success = false;
	const retryDelay = 1000;

	if (!browser) return;

	while (attempt < maxRetries && !success) {
		try {
			const controller = new AbortController();
			const timeoutId = setTimeout(() => controller.abort(), 10000); // Increased timeout to 10 seconds

			const res = await fetch(
				`https://us-central1-staging-ac5f0.cloudfunctions.net/getInitialProducts`,
				{
					method: 'GET',
					headers: {
						'Content-Type': 'application/json'
					},
					mode: 'cors',
					signal: controller.signal
				}
			);

			clearTimeout(timeoutId);

			if (!res.ok) {
				throw new Error(`Failed to fetch products: ${res.status} ${res.statusText}`);
			}

			const items = await res.json();
			const filteredItems = items.filter((it) => it.featured_image && it.featured_image !== '');
			productStore.set(filteredItems);
			success = true;
		} catch (e) {
			attempt++;
			if (e.name === 'AbortError') {
				console.error('Fetch request timed out:', e);
			} else {
				console.error('Error calling Firebase Cloud Function:', e);
			}
			if (attempt >= maxRetries) {
				throw new Error(`Failed to fetch products after ${maxRetries} attempts: ${e.message}`);
			}
			logError(e, 'products.js:fetchData');
			console.log(`Retrying in ${retryDelay}ms... (Attempt ${attempt}/${maxRetries})`);
			await new Promise((resolve) => setTimeout(resolve, retryDelay));
		}
	}
}

export let activeProductsStore = derived(productStore, ($products) => {
	try {
		let arr = [];
		$products.forEach((item) => {
			if (item.stock > 0 && item.featured_image && item.featured_image !== '') arr.push(item);
		});
		return arr;
	} catch (error) {
		console.error('Error processing active products:', error);
		return [];
	}
});

export let highlightedProductStore = derived(productStore, ($products) => {
	try {
		let arr = [];
		$products.forEach((item) => {
			if (item.highlighted && item.featured_image && item.featured_image !== '') {
				arr.push(item);
			}
		});
		return arr;
	} catch (error) {
		console.error('Error processing highlighted products:', error);
		return [];
	}
});

export let latestProductsStore = derived(prizes, ($prizes) => {
	try {
		let arr = [];
		arr = $prizes.filter((item) => item.stock > 0);
		arr = arr.sort((x, y) => x.createdAt - y.createdAt);
		return arr.slice(0, 5);
	} catch (error) {
		console.error('Error processing latest products:', error);
		return [];
	}
});

export let endingProductsStore = derived(prizes, ($prizes) => {
	try {
		let arr = [];
		$prizes.forEach((item) => {
			const daysLeft = daysRemaining(item?.endDate);
			if (daysLeft < 4 && item.stock > 0) {
				arr.push(item);
			}
			// Limit the number of items to 5
			if (arr.length >= 5) {
				return arr;
			}
		});

		// If there are fewer than 5 items, return the full array
		return arr.slice(0, 5);
	} catch (error) {
		console.error('Error processing ending products:', error);
		return [];
	}
});

export let recentlyEndedStore = derived(productStore, ($productStore) => {
	try {
		let arr = [];
		$productStore.forEach((item) => {
			if (item.stock == 0) arr.push(item);
		});
		return arr;
	} catch (error) {
		console.error('Error processing recently ended products:', error);
		return [];
	}
});

// async function createProducts() {
//   const firestoreDb = await db()
//   const { subscribe } = readable([], set => {
//     let unsubscribe = () => {}

//     if (browser) {
//       let q = query(collection(firestoreDb, 'products'), where('stock', '>', 0))
//       q = query(q, orderBy('stock', 'asc'))
//     //   q = query(q, limit(10))

//       unsubscribe = onSnapshot(q, snap => set(snap.docs.map(doc => ({ ...doc.data(), id: doc.id }))))
//     }

//     return unsubscribe
//   })

//   return { subscribe }
// }

// export const prizes = createProducts()
